import React, { Component } from "react";
import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import d3 from "d3";
import AnalyticsHeader from "visual-components/analyticsDashboard/analytics-header";
import LabeledBarChart from "./LabeledBarChart";
import EntryContributionTooltip from "visual-components/analyticsDashboard/tooltip/EntryContributionTooltip";

export default class EntryContributionCard extends Component {
  render() {
    const { data, isHost, filterWebbula, started } = this.props;

    const totalEntries = data.reduce((sum, item) => sum + item.entries, 0);

    const tooltipText =
      "Entry Contribution shows the total number of entries from all brands combined at the top and then below you will see a list of each brand's separate contribution. This list shows the breakdown of how many entries/signups came from each individual brand participating in the campaign!";

    // Only show threshold tooltip for hosts
    const tooltip = isHost ? (params) => <EntryContributionTooltip {...params} /> : null;

    return (
      <Card sx={{ height: "100%" }}>
        <CardHeader
          title={<AnalyticsHeader title="Entry Contribution" tooltipText={tooltipText} />}
        />
        <CardContent>
          <Box>
            <Typography variant="h5" component="span" sx={{ fontWeight: "bold" }}>
              {started ? d3.format(",")(totalEntries) : 0}
            </Typography>
            <Typography variant="h6" component="span" sx={{ ml: 1, color: "text.secondary" }}>
              total entries
            </Typography>
          </Box>

          <LabeledBarChart
            data={data}
            enabled={started}
            labelField="accountname"
            valueField="entries"
            thresholdField={isHost ? "threshold" : undefined}
            tooltip={tooltip}
          />
        </CardContent>
      </Card>
    );
  }
}
